import Vue from "vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import moment from "moment";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { DateTime } from "luxon";

export default {
  name: "Store",
  mixins: [validationMixin],
  components: {
    datetime: Datetime,
    DateTime,
    SelectFromList: require("@/components/selectFromList/selectFromList.vue")
      .default,
  },
  props: ["dataObj"],
  data: function () {
    return {
      station: {},
      savedCost: -1,
      store: {
        comment: "",
        cost: 0,
        destinationWarehouse: "",
        destinationWarehouseId: 0,
        dt: moment(new Date()).format(),
        inventoryId: 0,
        inventoryName: "",
        sourceWarehouse: "",
        sourceWarehouseId: 0,
        stockQuantity: 0,
        takenQuantity: 0,
        total: 0,
        usedQuantity: 0,
      },
      dt: "",
      inventoryGroupId: 0,
      inventory: { text: "", value: "" },
      inventoryGroup: { text: "", value: "" },
      sourceWarehouse: { text: "", value: "" },
      destinationWarehouse: { text: "", value: "" },
      inventories: [],
      allInventories: [],
      inventoryGroups: [],
      selection: [],
      stockQty: 0,
      preference: {},
      selectedWarehouse: {},
    };
  },
  computed: {
    selectionCount: function () {
      return this.selection.length;
    },
    totalForDisplay: {
      get: function () {
        return this.twoDecimals(this.store.total);
      },
      set: function () {},
    },
    inventoriesForSelect: function () {
      return this.inventories.map((item) => {
        return {
          name: item.name,
          id: item.id,
        };
      });
    },
    warehouses: function () {
      // if (this.station && this.station.value != null)
      //   return this.dataObj.warehouses.filter(
      //     (w) => w.group.id == this.station.value
      //   );
      // else
      return this.dataObj.warehouses;
    },
  },
  watch: {
    selectionCount: function (value) {
      this.dataObj.selection = [];
      if (value === 0) return;
      this.selection.forEach((p) => this.dataObj.selection.push(p.id));
      this.selection = this.selection;
    },
    dt: function (val) {
      this.dataObj.dt = moment(val).format();
    },
    inventory: function (value) {
      if (!value) return;
      this.dataObj.inventoryId = value.id;
      this.dataObj.inventoryName = value.name;

      if (this.savedCost > 0) {
        this.dataObj.cost = this.savedCost;
        this.savedCost = 0;
        this.calculateCost();
      } else this.dataObj.cost = value.cost;

      this.fillQtyStock();
    },
    inventoryGroup: function (value) {
      if (!value || !value.value) return;

      if (value.value < 0)
        //filter all option
        this.inventories = this.dataObj.inventories;
      else
        this.inventories = this.dataObj.inventories.filter(
          (p) => p.groupId == value.value
        );
    },
    sourceWarehouse: function (value) {
      if (!value || !value.value) return;

      this.store.sourceWarehouse = value.text;
      this.store.sourceWarehouseId = value.value;

      this.store.stockQuantity = this.stockQty;

      this.fillQtyStock();
    },
    destinationWarehouse: function (value) {
      if (!value || !value.value) return;

      this.store.destinationWarehouse = value.text;
      this.store.destinationWarehouseId = value.value;
    },
  },
  created() {
    this.init();
    console.log("store data", { ...this.dataObj });
  },
  methods: {
    resetDropDowns(type = "all") {
      if (type == "all") this.inventorySelected();

      //this.wareHouseSelected();
    },
    stationSelected(item) {
      this.station = item;
    },
    inventorySelected(item) {
      if (item)
        this.inventory = this.inventories.filter((i) => i.id == item.id)[0];
      else this.inventory = null;
    },
    wareHouseSelected(item) {
      if (item) {
        this.sourceWarehouse = item;
        this.destinationWarehouse = item;
      }
    },
    twoDecimals(value) {
      return value != null && value > 0 ? parseFloat(value).toFixed(2) : 0;
    },
    getSelectedWarehouse() {
      this.preference = JSON.parse(this.$localStorage.get("_preference"));
      let selWare = this.dataObj.warehouses.filter(
        (p) => p.value == this.preference.warehouseId
      );

      if (selWare != null && selWare.length > 0)
        this.selectedWarehouse = selWare[0];
    },
    fillQtyStock() {
      //error check
      if (
        this.sourceWarehouse.value < 0 ||
        !this.inventory ||
        this.inventory.id < 0
      )
        return;

      let stckQty =
        this.inventory.wareHouseQuantities[this.sourceWarehouse.value];
      this.store.stockQuantity = stckQty != null && stckQty > 0 ? stckQty : 0;
    },
    checkUsedQty() {
      if (this.store.usedQuantity > this.store.takenQuantity) {
        this.$alertMsg(this.$t("validation.qtyUsedGreaterQtyTaken"), 3);
        this.store.usedQuantity = this.store.takenQuantity;
      }
      this.calculateCost();
    },
    calculateCost() {
      this.store.total = this.store.cost * this.store.usedQuantity;
    },
    init() {
      Vue.nextTick(() => {
        this.dataObj.isMultiple = false;
        this.stockQty = this.store.stockQuantity;
        this.savedCost = this.dataObj.cost;
        this.store = this.dataObj;
        this.dt = this.dataObj.dt;
        this.inventories = this.dataObj.inventories;
        this.inventoryGroups = this.dataObj.inventoryGroups;
        this.inventoryGroup = this.dataObj.inventoryGroups.filter(
          (p) => p.selected
        )[0];
        this.inventory = this.dataObj.inventories.filter(
          (p) => p.id == this.dataObj.inventoryId
        )[0];

        this.getSelectedWarehouse();
        let destinationWarehouse = {
          value: this.store.destinationWarehouseId,
          text: this.store.destinationWarehouse,
        };

        if (this.store.sourceWarehouseId > 0) {
          this.sourceWarehouse = {
            text: this.store.sourceWarehouse,
            value: this.store.sourceWarehouseId,
          };
        } else if (this.selectedWarehouse && this.selectedWarehouse.value > 0) {
          this.sourceWarehouse = { ...this.selectedWarehouse };
        } else {
          this.sourceWarehouse = { text: "", value: "" };
        }

        if (destinationWarehouse.value > 0) {
          this.destinationWarehouse = { ...destinationWarehouse };
        } else if (this.sourceWarehouse.value > 0) {
          this.destinationWarehouse = { ...this.sourceWarehouse };
        } else {
          this.destinationWarehouse = { text: "", value: "" };
        }

        this.store.cost = this.savedCost;
      });
    },
  },
  validations: {
    warehousesource: {
      required,
    },
    warehousedest: {
      required,
    },
    inventory: {
      required,
    },
  },
};
